import { StyleSheet } from 'aphrodite';
import { hexToRGBA } from '../../../../../models/UiUtils';
import { CssSelectors } from '../../../../../web/styles/styles';

import { THEME } from '../../../../../web/components-v2/Theme/theme';
const { spacing, common, colors, typography } = THEME;

export const styleSheet = StyleSheet.create({
	rsvpForm: {
		maxWidth: 1024,
		width: '100%',
	},
	rsvpInfo: {
		'@media only screen and (min-width: 1024px)': {
			flexDirection: 'row',
			justifyContent: 'space-between',
			margin: '24px auto 0',
			width: '100%',
			gap: 24,
			...CssSelectors.allChildren(
				{
					width: '100%',
				},
				'div'
			),
		},

		display: 'flex',
		flexDirection: 'column',
		marginTop: 12,
		paddingTop: 12,
	},
	formControl: {
		'@media only screen and (min-width: 1024px)': {
			maxWidth: '33%',
		},
		marginBottom: spacing.md,
		textAlign: 'left',
		width: '100%',
		...CssSelectors.allChildren(
			{
				color: colors.text.main,
				fontSize: typography.fontSizes.xs,
			},
			'small'
		),
	},
	formControlFullWidth: {
		marginBottom: spacing.md,
		textAlign: 'left',
		width: '100%',
	},
	label: {
		color: colors.text.main,
		display: 'block',
		fontSize: typography.fontSizes.sm,
		margin: `0 0 ${spacing.xs}px`,
		textAlign: 'left',
	},
	addAnotherGuestButton: {
		color: colors.hover.main,
		margin: `0 0 ${spacing.xs}px`,
	},
	removeGuestIcon: {
		verticalAlign: 'middle',
	},
	noMargin: {
		margin: 0,
	},
	errorMessage: {
		color: colors.danger.main,
	},
	guestInfoError: {
		display: 'flex',
		justifyContent: 'flex-start',
		marginBottom: 6,
	},
	rsvpOptions: {
		'@media only screen and (min-width: 768px)': {
			flexDirection: 'row',
			margin: `${spacing.lg}px auto ${spacing.lg}px`,
			maxWidth: 1024,
			padding: spacing.lg,
		},
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		marginLeft: 0,
		marginRight: 0,
		marginTop: spacing.lg,
		marginBottom: spacing.lg,
		padding: spacing.md,
	},
	radio: {
		':not(:last-child)': {
			margin: '0 0 12px 0',
		},
		'@media only screen and (min-width: 768px)': {
			':not(:last-child)': {
				margin: '0 12px 0 0',
			},
			margin: 0,
		},
		'@media only screen and (min-width: 1024px)': {
			':not(:last-child)': {
				margin: '0 90px 0 0',
			},
			margin: 0,
		},
	},
	plusOneOptionWrap: {
		'@media only screen and (min-width: 1024px)': {
			margin: '24px auto 0',
			width: '100%',
		},
		display: 'flex',
		flexDirection: 'column',
		marginTop: spacing.lg,
	},
	checkbox: {
		gap: 8,
		fontSize: typography.fontSizes.sm,
		color: colors.text.main,
	},
	actions: {
		width: '100%',
	},
	buttonContainer: {
		display: 'inline-flex',
		marginBottom: spacing.xl,
		marginTop: spacing.lg,
		gap: spacing.sm,
	},
	divider: {
		maxWidth: 1024,
		width: '100%',
		borderTop: `2px solid ${colors.border.main}`,
	},
	guestInfo: {
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.lg,
		alignItems: 'center',
	},
	disabledGuestInfo: {
		opacity: 0.5,
	},
	bringingGuestsLabel: {
		marginLeft: 6,
	},
	textInput: {
		width: '100%',
		boxSizing: 'border-box',
	},
	textArea: {
		height: 68,
	},
	selectBoxtriggerButton: {
		border: `1px solid ${colors.border.main}`,
		background: hexToRGBA(colors.border.main, 0.3),
		borderRadius: common.borderRadius,
	},
	required: {
		color: colors.danger.main,
	},
	paymentInfoTitle: {
		color: colors.text.main,
		margin: `0 0 ${spacing.md}px`,
	},
	orderInfo: {
		color: colors.text.main,
		...CssSelectors.allDescendants(
			{
				color: colors.text.main,
			},
			'strong'
		),
	},
	paymentInfo: {
		display: 'flex',
		flexDirection: 'column',
		textAlign: 'left',
		paddingBottom: spacing.md,
		boxSizing: 'border-box',
		...CssSelectors.allDescendants(
			{
				marginBottom: spacing.md,
				color: colors.text.main,
				margin: 0,
			},
			'p'
		),
		...CssSelectors.allChildren(
			{
				marginTop: spacing.lg,
				paddingBottom: spacing.md,
			},
			'div'
		),
		...CssSelectors.allDescendants(
			{
				color: colors.text.main,
			},
			'strong'
		),
	},
	paymentInfoText: {
		color: colors.border.main,
		...CssSelectors.allChildren(
			{
				fontSize: typography.fontSizes.sm,
			},
			'span'
		),
		...CssSelectors.allChildren(
			{
				color: colors.text.main,
			},
			'strong'
		),
	},
	modal: {
		...CssSelectors.allChildren(
			{
				background: hexToRGBA(colors.background.light, 0.4),
				...CssSelectors.allDescendants(
					{
						width: '100%',
						maxWidth: 400,
						boxSizing: 'border-box',
					},
					'.modal-overlay-content-after-open'
				),
			},
			'.modal-overlay-after-open'
		),
	},
	submitButton: {
		margin: '8px 0 8px',
		width: '100%',
	},
	paidTickets: {
		marginTop: spacing.md,
		marginBottom: spacing.md,
	},
	timesSymbol: {
		color: colors.text.main,
		fontSize: typography.fontSizes.md,
	},
	warningMessage: {
		maxWidth: 370,
		color: colors.text.main,
		fontSize: typography.fontSizes.sm,
		...CssSelectors.allDescendants(
			{
				color: colors.danger.main,
			},
			'span'
		),
	},
	closeButton: {
		position: 'absolute',
		top: 0,
		right: 0,
		fontSize: 0,
		width: 14,
		height: 14,
	},
	header: {
		position: 'relative',
	},
});
